import type { ReactNode } from 'react';
import { PATHS } from '@/constants/path';

/**
 * next-intl の `t.rich` 用リンクレンダラを生成する。
 * 規約系リンクを下線付き・別タブの `<a>` で描画する。
 *
 * @example
 * t.rich('...', { privacy_link: privacyLink })
 */
export const legalLink =
  (href: string) =>
  (chunks: ReactNode): ReactNode => (
    <a href={href} target='_blank' rel='noopener noreferrer' className='underline'>
      {chunks}
    </a>
  );

/** 利用規約・プライバシーポリシー・コミュニティガイドラインの標準リンクレンダラ */
export const termLink = legalLink(PATHS.TERMS);
export const privacyLink = legalLink(PATHS.PRIVACY_POLICY);
export const guidelineLink = legalLink(PATHS.GUIDE_LINE);
